(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hw-product-size-help"] && !Shopify.designMode) return;
  try {
    let activeSizeModal;
  let sizeModalTrigger;
  let previousSizeModalOverflow = '';
  const sizeModalObserver = new MutationObserver(() => {
    if (activeSizeModal && (!activeSizeModal.isConnected || !activeSizeModal.open)) closeSizeModal();
  });
  function closeSizeModal() {
    if (!activeSizeModal) return;
    const modal = activeSizeModal;
    activeSizeModal = undefined;
    sizeModalObserver.disconnect();
    if (modal.open) modal.close();
    document.body.style.overflow = previousSizeModalOverflow;
    if (sizeModalTrigger?.isConnected) sizeModalTrigger.focus({ preventScroll: true });
    sizeModalTrigger = undefined;
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-hw-size-trigger]');
    if (trigger) {
      if (trigger.closest('quick-add-dialog, product-card, featured-product-information')) return;
      if (!trigger.closest('main .product-information')) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const modal = Array.from(trigger.closest('variant-picker')?.querySelectorAll('[data-hw-size-modal]') || [])
        .find((dialog) => dialog.id === trigger.getAttribute('aria-controls'));
      if (!(modal instanceof HTMLDialogElement) || typeof modal.showModal !== 'function') return;
      event.preventDefault();
      closeSizeModal();
      previousSizeModalOverflow = document.body.style.overflow;
      sizeModalTrigger = trigger;
      activeSizeModal = modal;
      modal.showModal();
      modal.scrollTop = 0;
      const content = modal.querySelector('.hw-size-guide__content');
      if (content) content.scrollTop = 0;
      document.body.style.overflow = 'hidden';
      sizeModalObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    } else if (activeSizeModal && (event.target === activeSizeModal || event.target.closest('[data-hw-size-close]'))) {
      closeSizeModal();
    } else if (activeSizeModal && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const link = event.target.closest('.hw-size-guide__content a[href^="#"]');
      if (!link || !activeSizeModal.contains(link)) return;
      const target = Array.from(activeSizeModal.querySelectorAll('[id]'))
        .find((element) => element.id === link.hash.slice(1));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ block: 'start' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }
  });
  document.addEventListener('keydown', (event) => {
    if (activeSizeModal && event.key === 'Tab') {
      const focusable = Array.from(activeSizeModal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter((element) => element.getClientRects().length > 0);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !activeSizeModal.contains(document.activeElement))) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !activeSizeModal.contains(document.activeElement))) {
        event.preventDefault();
        first?.focus();
      }
    }
  });
  document.addEventListener('cancel', (event) => {
    if (event.target === activeSizeModal) { event.preventDefault(); closeSizeModal(); }
  }, true);
  document.addEventListener('close', (event) => {
    if (event.target === activeSizeModal) closeSizeModal();
  }, true);
  document.addEventListener('change', (event) => {
    if (activeSizeModal && event.target instanceof Element && event.target.closest('variant-picker') === activeSizeModal.closest('variant-picker')) closeSizeModal();
  }, true);
  window.addEventListener('pagehide', closeSizeModal);
  } catch(e) { console.error(e); }
})();

})();
